import { FIRMWARE_ROUTES } from 'shared/consts/routes/firmware';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={FIRMWARE_ROUTES.ADD_FIRMWARE}
      requiredRights={[
        {
          controller: 'Firmware',
          right: 'Write',
        },
      ]}
    />
  );
}
